export class EventEmitter {
  on() { return this; }
  once() { return this; }
  off() { return this; }
  emit() { return false; }
  addListener() { return this; }
  removeListener() { return this; }
  removeAllListeners() { return this; }
  listeners() { return []; }
  listenerCount() { return 0; }
  setMaxListeners() { return this; }
  getMaxListeners() { return 10; }
}

// Node's events.once(emitter, name) promise helper. The SDK's folder-sync
// imports it, but the console never runs that path; fail loud like the other
// stubs rather than returning a promise that would hang the caller forever.
export function once() {
  throw new Error("events.once is not available in the console browser build");
}

export default { EventEmitter, once };
